import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CommonService } from '../../shared/common.service';
import { HomeService } from '../home.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import {
  ChangeDetectorRef,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
} from '@angular/core';
import { EventEmitter } from 'events';
import Swal from 'sweetalert2';
import { StreamService } from '../../shared/stream.service';
import { ViewProfileModalComponent } from '../view-profile-modal/view-profile-modal.component';
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../dashboard/dashboard.service';
import { th } from 'date-fns/locale';

@Component({
  selector: "app-edit-user-profile",
  templateUrl: "./edit-user-profile.component.html",
  styleUrls: ["./edit-user-profile.component.css"],
})
export class EditUserProfileComponent implements OnInit {
  @Output() imageUploaded = new EventEmitter();
  @Output() imageError = new EventEmitter();
  @Output() imageLoadedToContainer = new EventEmitter();
  @Output() croppingCanceled = new EventEmitter();
  selectedFile: File;
  datalist: [1, 2, 3, 4, 5, 6, 7, 8, 9];
  condition: boolean = false;
  noPattern: string = '';
  userId: any;
  isLoading: boolean = false;
  userDetails: any;
  circleId = "";
  fromType: string;
  pattern: string = '[a-zA-Z\s]+$';
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  urlPattern = "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?";
  userAboutForm: FormGroup;
  MembershipForm: FormGroup;
  InstituteForm: FormGroup;
  profExpForm: FormGroup;
  researchExpForm: FormGroup;
  fundingForm: FormGroup;
  WorkgroupsForm: FormGroup;
  roleList: Array<object> = [];
  diseaseList: Array<object> = [];
  focusList: Array<object> = [
    { name: "Focus 1" },
    { name: "Focus 2" },
    { name: "Focus 3" },
  ];
  ExpLevelList: Array<object> = [
    { name: "Early stage (0-3 years)" },
    { name: "Mid-level (3-7 years)" },
    { name: "Experienced (More than 7 years)" },
  ];
  studyTypeList: Array<object> = [
    { name: "Interventional" },
    { name: "Observational" },
    { name: "Registry" },
  ];
  studyPhaseList: Array<object> = [
    { name: "Early Phase 1" },
    { name: "Phase 1" },
    { name: "Phase 2" },
    { name: "Phase 3" },
    { name: "Phase 4" },
    { name: "Not Applicable" },
  ];
  isChange: boolean = false;
  membershipList: Array<object> = [];
  education: Array<object> = [];
  professionalExp: Array<object> = [];
  researchExp: Array<object> = [];
  fundingHistory: Array<object> = [];
  socialLinkList = [];
  publications = [];
  publicationText: string = "";
  socialLink: string = "";
  socialLinkType: string = "";
  commentText: string = "";
  userRole = "researcher"
  contactInfoShow: boolean = false;
  educationShow: boolean = false;
  fundingHistoryShow: boolean = false;
  membershipShow: boolean = false;
  nbstrnShow: boolean = false;
  professionalExpShow: boolean = false;
  publicationsShow: boolean = false;
  researchExpShow: boolean = false;
  expertCount: number = 0;
  imageChangedEvent: any = "";
  croppedImage: any = "";
  private modalRef: NgbModalRef;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size: "xl",
  };
  closeResult: string;
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: "userRoleId",
    textField: "roleName",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  dropdownSettingDepartment: IDropdownSettings = {
    singleSelection: false,
    idField: "department",
    textField: "department",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  
  dropdownSettings1: IDropdownSettings = {
    singleSelection: false,
    idField: "value",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  dropdownSettings3: IDropdownSettings = {
    singleSelection: false,
    idField: "name",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  dropdownSettings4: IDropdownSettings = {
    singleSelection: true,
    idField: "name",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  dropdownSettings5: IDropdownSettings = {
    singleSelection: false,
    idField: "name",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  dropdownSettings6: IDropdownSettings = {
    singleSelection: false,
    idField: "name",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  dropdownSettingCountry: IDropdownSettings = {
    singleSelection: true,
    idField: "code",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  dropdownSettingCircle: IDropdownSettings = {
    singleSelection: false,
    idField: "circleId",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  subscribedPage: any;
  circleList = [];
  from = ""
  departmentList = [];
  userData:any;
  roleData = [
    {name:"Researcher",value:"coordinator"},
    {name:"CTO",value:"cto"},
    {name:"Admin",value:"admin"},
    {name:"Principal Investigator",value:"principalInvestigator"},
    {name:"Research Admin",value:"researchAdmin"},
    {name:"CTMS Support",value:"ctmsSupport"},
  ]
 
  countryList = [
    { name: "Albania", code: "AL" },
    { name: "Åland Islands", code: "AX" },
    { name: "Algeria", code: "DZ" },
    { name: "American Samoa", code: "AS" },
    { name: "Andorra", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Anguilla", code: "AI" },
    { name: "Antarctica", code: "AQ" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Aruba", code: "AW" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahamas (the)", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bermuda", code: "BM" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia (Plurinational State of)", code: "BO" },
    { name: "Bonaire, Sint Eustatius and Saba", code: "BQ" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Bouvet Island", code: "BV" },
    { name: "Brazil", code: "BR" },
    { name: "British Indian Ocean Territory (the)", code: "IO" },
    { name: "Brunei Darussalam", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cabo Verde", code: "CV" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cayman Islands (the)", code: "KY" },
    { name: "Central African Republic (the)", code: "CF" },
    { name: "Chad", code: "TD" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Christmas Island", code: "CX" },
    { name: "Cocos (Keeling) Islands (the)", code: "CC" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros (the)", code: "KM" },
    { name: "Congo (the Democratic Republic of the)", code: "CD" },
    { name: "Congo (the)", code: "CG" },
    { name: "Cook Islands (the)", code: "CK" },
    { name: "Costa Rica", code: "CR" },
    { name: "Croatia", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Curaçao", code: "CW" },
    { name: "Cyprus", code: "CY" },
    { name: "Czechia", code: "CZ" },
    { name: "Côte d'Ivoire", code: "CI" },
    { name: "Denmark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic (the)", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Equatorial Guinea", code: "GQ" },
    { name: "Eritrea", code: "ER" },
    { name: "Estonia", code: "EE" },
    { name: "Eswatini", code: "SZ" },
    { name: "Ethiopia", code: "ET" },
    { name: "Falkland Islands (the) [Malvinas]", code: "FK" },
    { name: "Faroe Islands (the)", code: "FO" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "French Guiana", code: "GF" },
    { name: "French Polynesia", code: "PF" },
    { name: "French Southern Territories (the)", code: "TF" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia (the)", code: "GM" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Gibraltar", code: "GI" },
    { name: "Greece", code: "GR" },
    { name: "Greenland", code: "GL" },
    { name: "Grenada", code: "GD" },
    { name: "Guadeloupe", code: "GP" },
    { name: "Guam", code: "GU" },
    { name: "Guatemala", code: "GT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and McDonald Islands", code: "HM" },
    { name: "Holy See (the)", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iran (Islamic Republic of)", code: "IR" },
    { name: "Iraq", code: "IQ" },
    { name: "Ireland", code: "IE" },
    { name: "Isle of Man", code: "IM" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kiribati", code: "KI" },
    { name: "Korea (the Democratic People's Republic of)", code: "KP" },
    { name: "Korea (the Republic of)", code: "KR" },
    { name: "Kuwait", code: "KW" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: "Lao People's Democratic Republic (the)", code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libya", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Marshall Islands (the)", code: "MH" },
    { name: "Martinique", code: "MQ" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mayotte", code: "YT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia (Federated States of)", code: "FM" },
    { name: "Moldova (the Republic of)", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montenegro", code: "ME" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands (the)", code: "NL" },
    { name: "New Caledonia", code: "NC" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger (the)", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands (the)", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Palau", code: "PW" },
    { name: "Palestine, State of", code: "PS" },
    { name: "Panama", code: "PA" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines (the)", code: "PH" },
    { name: "Pitcairn", code: "PN" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Puerto Rico", code: "PR" },
    { name: "Qatar", code: "QA" },
    { name: "Republic of North Macedonia", code: "MK" },
    { name: "Romania", code: "RO" },
    { name: "Russian Federation (the)", code: "RU" },
    { name: "Rwanda", code: "RW" },
    { name: "Réunion", code: "RE" },
    { name: "Saint Barthélemy", code: "BL" },
    { name: "Saint Helena, Ascension and Tristan da Cunha", code: "SH" },
    { name: "Saint Kitts and Nevis", code: "KN" },
    { name: "Saint Lucia", code: "LC" },
    { name: "Saint Martin (French part)", code: "MF" },
    { name: "Saint Pierre and Miquelon", code: "PM" },
    { name: "Saint Vincent and the Grenadines", code: "VC" },
    { name: "Samoa", code: "WS" },
    { name: "San Marino", code: "SM" },
    { name: "Sao Tome and Principe", code: "ST" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Serbia", code: "RS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Sint Maarten (Dutch part)", code: "SX" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Solomon Islands", code: "SB" },
    { name: "Somalia", code: "SO" },
    { name: "South Africa", code: "ZA" },
    { name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { name: "South Sudan", code: "SS" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sudan (the)", code: "SD" },
    { name: "Suriname", code: "SR" },
    { name: "Svalbard and Jan Mayen", code: "SJ" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Syrian Arab Republic", code: "SY" },
    { name: "Taiwan (Province of China)", code: "TW" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Tanzania, United Republic of", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tokelau", code: "TK" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Turkmenistan", code: "TM" },
    { name: "Turks and Caicos Islands (the)", code: "TC" },
    { name: "Tuvalu", code: "TV" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    {
      name: "United Kingdom of Great Britain and Northern Ireland (the)",
      code: "GB",
    },
    { name: "United States Minor Outlying Islands", code: "UM" },
    { name: "United States of America", code: "US" },
    { name: "Uruguay", code: "UY" },
    { name: "Uzbekistan", code: "UZ" },
    { name: "Vanuatu", code: "VU" },
    { name: "Venezuela (Bolivarian Republic of)", code: "VE" },
    { name: "Viet Nam", code: "VN" },
    { name: "Virgin Islands (British)", code: "VG" },
    { name: "Virgin Islands (U.S.)", code: "VI" },
    { name: "Wallis and Futuna", code: "WF" },
    { name: "Western Sahara", code: "EH" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
  ];
  projectDetailSign: any;
  countryShow: boolean = false;
  roleShow: boolean = false;
  notificationPrefOptions = [
    { key: "chat", label: "Chat" },
    { key: "dashboard", label: "Dashboard" },
    { key: "events", label: "Events" },
    { key: "forms", label: "Forms" },
  ];
  notificationPrefDraft: { [key: string]: boolean } = {};
  isSavingNotificationPref: boolean = false;
  circlesOfInterestShow: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private CircleService: HomeService,
    private router: Router,
    private fb: FormBuilder,
    private streamService: StreamService,
    private Common: CommonService,
    private _snackBar: MatSnackBar,
    private modalService: NgbModal,
    private authServices:DashboardService
  ) {}

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("userData")) || "noemail";
    this.route.queryParams.subscribe((param) => {
      this.userId = param["userId"];
      this.from = param["from"];
      this.getUserProfile();
    });
  
    this.projectDetailSign =
      JSON.parse(localStorage.getItem("project_Signup")) || "noemail";

    this.subscribedPage = this.streamService
      .getFilterSubscription()
      .subscribe((data: string) => {
        if (data == "CLOSE") {
          this.modalRef.close();
        }
      });
    this.getUserRole();
    this.getDiesease();
    this.getFocus();
    this.getPubclicCircle();
    this.initialiseForms();
    this.getUserProfile();
    this.updateField();
    this.getDepartment();
  }
  updateField() {
    this.projectDetailSign[0]["configurations"].forEach((element) => {
      if (element["type"] == "country") {
        this.countryShow = element["isUsed"];
      }
      if (element["type"] == "role") {
        this.roleShow = element["isUsed"];
      }
      if (element["type"] == "circlesOfInterest") {
        this.circlesOfInterestShow = element["isUsed"];
      }
    });
    if (this.roleShow == false) {
      this.userAboutForm.controls["roleIds"].setValidators([
        Validators.nullValidator,
      ]);
      this.userAboutForm.controls["roleIds"].updateValueAndValidity();
    }
    if (this.countryShow == false) {
      this.userAboutForm.controls["country"].setValidators([
        Validators.nullValidator,
      ]);
      this.userAboutForm.controls["country"].updateValueAndValidity();
    }
    if (this.circlesOfInterestShow == false) {
      this.userAboutForm.controls["circlesOfInterest"].setValidators([
        Validators.nullValidator,
      ]);
      this.userAboutForm.controls["circlesOfInterest"].updateValueAndValidity();
    }
  }
  getPubclicCircle() {
    let query = "limit=1000";
    this.CircleService.getPublicCircle(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.circleList = res.data.circleList;
          // this.PatchCircle(this.circleDetails)
        } else {
          this.roleList = [];
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  initialiseForms() {
    this.userAboutForm = this.fb.group({
      fullName: ["", [Validators.required]], //done
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]], //done
      profilePic: [""],
      institution: ["", [Validators.required]],
      roleIds: [""], //done
      jobTitle: [""], //done
      mobile: ["", [Validators.minLength(10)]], //done], //done
      address: [""], //done
      researchFocus: [""], //done
      other: [""],
      department: [""],
      tuftsDepartment: [""],
      diseaseOfInterestIds: [""], //done
      introduction: [""],
      socialMediaLink: [""],
      country: [[]],
      circlesOfInterest: [[]],
    });
    this.MembershipForm = this.fb.group({
      institution: [""],
      department: [""],
      jobTitle: [""],
      comment: [""],
      membershipYear: [""],
    });

    this.InstituteForm = this.fb.group({
      institution: [""],
      degree: [""],
      year: [""],
      fieldOfStudy: [""],
    });
    this.profExpForm = this.fb.group({
      institution: [""],
      jobTitle: [""],
      yearStarted: [""],
      yearCompleted: [""],
    });
    this.fundingForm = this.fb.group({
      grantNo: [""],
      contractNo: [""],
      grantTitle: [""],
      agency: [""],
    });
    this.researchExpForm = this.fb.group({
      expLevel: [""],
      studyTypes: [""],
      studyPhases: [""],
      studiesCompleted: [""],
      studiesOngoing: [""],
    });
    this.WorkgroupsForm = this.fb.group({
      userAvailable: [false],
      comments: [""],
    });
  }

  patchUserForm(data) {
    this.userAboutForm.patchValue({
      fullName: data["fullName"],
      email: data["email"],
      profilePic: data["profilePic"],
      institution: data["institution"],
      jobTitle: data["jobTitle"],
      mobile: data["mobile"],
      department: data["department"],
      address: data["address"],
      other: data["other"],
      introduction: data["introduction"],
    });
    this.socialLinkList = data["socialMediaLink"];
    this.WorkgroupsForm.patchValue({
      userAvailable: data["nbstrn"]["userAvailable"],
      comments: data["nbstrn"]["comments"],
    });

    let tempRols = [];
    if (data["tuftsRole"].length > 0) {
      for (let i = 0; i < data["tuftsRole"].length; i++) {
        tempRols.push({
          userRoleId: data['tuftsRole'][i],
          roleName: data['tuftsRole'][i],
        });
      }
      this.userAboutForm.controls.roleIds.setValue(tempRols);
    }

    let tempCountry = [];
    if (data["country"]) {
      this.countryList.forEach((element) => {
        if (element["name"] == data["country"]) {
          tempCountry.push(element);
        }
      });

      this.userAboutForm.controls.country.setValue(tempCountry);
    }

    let tempCirclesOfInterestIds = [];
    if (data["circlesOfInterestIds"].length > 0) {
      var j;
      for (j = 0; j < data["circlesOfInterestIds"].length; j++) {
        tempCirclesOfInterestIds.push({
          circleId: data["circlesOfInterestIds"][j],
          name: data["circlesOfInterestNames"][j],
        });
      }
      this.userAboutForm.controls.circlesOfInterest.setValue(
        tempCirclesOfInterestIds
      );
    }
    let tempDepartment = [];
    if (data["tuftsDepartments"].length > 0) {
      var j;
      for (j = 0; j < data["tuftsDepartments"].length; j++) {
        tempDepartment.push({
          department: data["tuftsDepartments"][j],
        });
      }
      this.userAboutForm.controls.tuftsDepartment.setValue(
        tempDepartment
      );
    }

    setTimeout(() => {
      this.onItemSelectRole(null);
      this.onItemSelectCountry(null);
      this.onItemSelectCircle(null);
    }, 2000);
    let tempdisease = [];
    if (data["diseaseOfInterestIds"].length > 0) {
      var j;
      for (j = 0; j < data["diseaseOfInterestIds"].length; j++) {
        tempdisease.push({
          diseaseId: data["diseaseOfInterestIds"][j],
          diseaseName: data["diseaseOfInterestNames"][j],
        });
      }
      this.userAboutForm.controls.diseaseOfInterestIds.setValue(tempdisease);
    }
    let tempresearchFocus = [];
    if (data["researchFocus"].length > 0) {
      var k;
      for (k = 0; k < data["researchFocus"].length; k++) {
        tempresearchFocus.push({ name: data["researchFocus"][k] });
      }
      this.userAboutForm.controls.researchFocus.setValue(tempresearchFocus);
    }

    if (data["membership"].length > 0) {
      this.membershipList = data["membership"];
    }
    if (data["professionalExp"].length > 0) {
      this.professionalExp = data["professionalExp"];
    }
    if (data["publications"].length > 0) {
      this.publications = data["publications"];
    }
    if (data["education"].length > 0) {
      this.education = data["education"];
    }
    if (data["fundingHistory"].length > 0) {
      this.fundingHistory = data["fundingHistory"];
    }
  }
  patchresearchForm(data) {
    this.researchExpForm.patchValue({
      studiesCompleted: data["researchExp"]["studiesCompleted"],
      studiesOngoing: data["researchExp"]["studiesOngoing"],
    });

    let tempexpLevel = [];
    if (data["researchExp"]["expLevel"]) {
      if (
        data["researchExp"]["expLevel"] &&
        data["researchExp"]["expLevel"].lenght > 0
      ) {
        tempexpLevel.push({ name: data["researchExp"]["expLevel"] });
      }

      this.researchExpForm.controls.expLevel.setValue(tempexpLevel);
    }

    let tempstudyTypes = [];

    if (
      data["researchExp"].lenght > 0 &&
      data["researchExp"]["studyTypes"].length > 0
    ) {
      var i;
      for (i = 0; i < data["researchExp"]["studyTypes"].length; i++) {
        if (
          data["researchExp"]["studyTypes"][i] &&
          data["researchExp"]["studyTypes"][i] !== null
        ) {
          tempstudyTypes.push({ name: data["researchExp"]["studyTypes"][i] });
        }
      }
      this.researchExpForm.controls.studyTypes.setValue(tempstudyTypes);
    }

    let tempstudyPhase = [];
    if (
      data["researchExp"].lenght > 0 &&
      data["researchExp"]["studyPhases"].length > 0
    ) {
      var j;
      for (j = 0; j < data["researchExp"]["studyPhases"].length; j++) {
        if (
          data["researchExp"]["studyPhases"][j] &&
          data["researchExp"]["studyPhases"][j] !== null
        ) {
          tempstudyPhase.push({ name: data["researchExp"]["studyPhases"][j] });
        }
      }
      this.researchExpForm.controls.studyPhases.setValue(tempstudyPhase);
    }
  }

  getDepartment() {
    this.isLoading = true;
    let query = 'isAdmin=true'
    this.authServices.getDepartmentAPI(query).subscribe(
      res => {
        this.isLoading = false;
        if ((res["message"] == "Success")) {
          this.departmentList = res.data.departments;
        } else {
          this.departmentList = [];
        }
      },
      err => {
        this.isLoading = false;
      }
    );
  }

  updateForm() {    
   
    if (this.userAboutForm.invalid) {
      if (this.userAboutForm.value.fullName == "") {
        this._snackBar.open("Full Name is required", "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
      }
      if (this.userAboutForm.value.email == "") {
        this._snackBar.open("Email is required", "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
      }

      return;
    }

    // this.isLoading = true;
    let request = this.userAboutForm.value;
    request["nbstrn"] = this.WorkgroupsForm.value;
    request["publications"] = this.publications;
    request["researchExp"] = this.researchExpForm.value;
    request["socialMediaLink"] = this.socialLinkList;

    if (request["researchExp"]["expLevel"]) {
      request["researchExp"]["expLevel"] =
        request["researchExp"]["expLevel"][0]["name"];
    }

    //set studyTypes
    let tempstudyTypes = [];
    if (request["researchExp"]["studyTypes"].length > 0) {
      request["researchExp"]["studyTypes"].forEach((element) => {
        if (element == null || element == "undefined" || element == undefined) {
        } else {
          tempstudyTypes.push(element["name"] || element);
        }
      });
      request["researchExp"]["studyTypes"] = tempstudyTypes;
    }

    //set studyPhases
    let tempstudyPhases = [];
    if (request["researchExp"]["studyPhases"].length > 0) {
      request["researchExp"]["studyPhases"].forEach((element) => {
        if (element == null || element == "undefined" || element == undefined) {
        } else {
          tempstudyPhases.push(element["name"] || element);
        }
      });
      request["researchExp"]["studyPhases"] = tempstudyPhases;
    }
    //set Country
    if(request['country'] && request['country'].length >0) {
      request['country'] = request['country'][0]['name']
    } else {
      request['country'] = ""
    }

    if (request["researchExp"]["studiesCompleted"]) {
      request["researchExp"]["studiesCompleted"] = parseInt(
        request["researchExp"]["studiesCompleted"]
      );
    }

    if (request["researchExp"]["studiesOngoing"]) {
      request["researchExp"]["studiesOngoing"] = parseInt(
        request["researchExp"]["studiesOngoing"]
      );
    }

    //set diseaseOfInterestIds
    let tempdiseaseOfInterestIds = [];
    if (request["diseaseOfInterestIds"].length > 0) {
      request["diseaseOfInterestIds"].forEach((element) => {
        if (element !== null || element !== "undefined") {
          tempdiseaseOfInterestIds.push(element["diseaseId"] || element);
        }
      });
      request["diseaseOfInterestIds"] = tempdiseaseOfInterestIds;
    }
    //set researchFocus
    let tempresearchFocus = [];
    if (request["researchFocus"].length > 0 && this.isChange == false) {
      request["researchFocus"].forEach((element) => {
        if (
          (element["name"] && element["name"] !== null) ||
          element !== "undefined"
        ) {
          tempresearchFocus.push(element["name"] || element);
        }
      });
    } else {
      if(this.userAboutForm.controls.researchFocus.value !== "") {
        tempresearchFocus.push(this.userAboutForm.controls.researchFocus.value);
      } 
    } 
    if(request["researchFocus"].length !== 0  ) {
            request["researchFocus"] = tempresearchFocus
          } else {
            request["researchFocus"] = []
          }
    //set roleIds
    let temproleIds = [];

    if (request["roleIds"].length > 0) {
      request["roleIds"].forEach((element) => {
        if (
          (element["name"] && (element["name"] !== null) ||
          element !== "undefined")
        ) {
          temproleIds.push(element["userRoleId"] || element);
        }
      });
      request["tuftsRole"] = temproleIds;
    }
    let circlesOfInterest = [];
    let tempDepartment = [];
    if (request["circlesOfInterest"].length > 0) {
      request["circlesOfInterest"].forEach((element) => {
        circlesOfInterest.push(element["circleId"]);
      });
      request["circlesOfInterest"] = circlesOfInterest;
    }
    if (request["tuftsDepartment"].length > 0) {
      request["tuftsDepartment"].forEach((element) => {
        tempDepartment.push(element['department']);
      });
      request["tuftsDepartments"] = tempDepartment;
    } else {
      request["tuftsDepartments"] = [];
    }
delete request['tuftsDepartment']
delete request['roleIds']
    // request['tuftsRole']= this.userRole;
    request["fundingHistory"] = this.fundingHistory;
    request["professionalExp"] = this.professionalExp;
    request["education"] = this.education;
    request["membership"] = this.membershipList;
    if(this.userId && this.userId !== "") {
      request['userId']=this.userId;
    }
    this.CircleService.updateUserProfile(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this._snackBar.open("Profile updated successfully", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          request = []

          this.getUpdateProfile1();
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  getUpdateProfile1() {
    this.isLoading = true;
    let query = "";
    if (this.userId && this.userId !== "") {
      query = "?userId=" + this.userId;
    }
    this.CircleService.getUserProfileApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.userDetails = res.data;
          if(this.from == "admin") {
            return
            // this.router.navigate(["/main/setting/manage-user/member"]);
          }
          if(this.from == "admin1") {
            return
            // this.router.navigate(["/main/setting/manage-user/member"]);
          } else {
            localStorage.setItem("userData", JSON.stringify(this.userDetails));
          this.streamService.streamFilterMessage("profile_update");
          // this.router.navigate(["main/dashboard/event/discussion-board"]);
          }
          
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  url1: any;
  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: "image/jpeg" });
  }
  save1() {
    const blob = this.b64toBlob(this.croppedImage);
    this.imageChangedEvent = null;
    this.isLoading = true;
    this.CircleService.uploadImage(blob).subscribe(
      (res) => {
        if (res["message"] === "Success") {
          this.url1 = res.data.url;
        }
      },
      (err) => {}
    );
  }
  requestUrl: any;
  viewProfile() {
    if (this.userAboutForm.value.fullName == "") {
      this._snackBar.open("Full Name is required", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
    }
    if (this.userAboutForm.value.email == "") {
      this._snackBar.open("Email is required", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
    }

    this.requestUrl = this.userAboutForm.value;
    this.requestUrl["nbstrn"] = this.WorkgroupsForm.value;
    this.requestUrl["publications"] = this.publications;
    this.requestUrl["researchExp"] = this.researchExpForm.value;
    this.requestUrl["socialMediaLink"] = this.socialLinkList;

    if (this.requestUrl["researchExp"]["expLevel"]) {
      this.requestUrl["researchExp"]["expLevel"] = this.requestUrl[
        "researchExp"
      ]["expLevel"][0]["name"];
    }

    //set studyTypes
    let tempstudyTypes = [];
    if (this.requestUrl["researchExp"]["studyTypes"].length > 0) {
      this.requestUrl["researchExp"]["studyTypes"].forEach((element) => {
        tempstudyTypes.push(element["name"]);
      });
      this.requestUrl["researchExp"]["studyTypes"] = tempstudyTypes;
    }

    //set studyPhases
    let tempstudyPhases = [];
    if (this.requestUrl["researchExp"]["studyPhases"].length > 0) {
      this.requestUrl["researchExp"]["studyPhases"].forEach((element) => {
        tempstudyPhases.push(element["name"]);
      });
      this.requestUrl["researchExp"]["studyPhases"] = tempstudyPhases;
    }

    if (this.requestUrl["researchExp"]["studyPhases"].length > 0) {
      this.requestUrl["researchExp"]["studyPhases"].forEach((element) => {
        tempstudyPhases.push(element["name"]);
      });
      this.requestUrl["researchExp"]["studyPhases"] = tempstudyPhases;
    }

    if (this.requestUrl["researchExp"]["studiesCompleted"]) {
      this.requestUrl["researchExp"]["studiesCompleted"] = parseInt(
        this.requestUrl["researchExp"]["studiesCompleted"]
      );
    }

    if (this.requestUrl["researchExp"]["studiesOngoing"]) {
      this.requestUrl["researchExp"]["studiesOngoing"] = parseInt(
        this.requestUrl["researchExp"]["studiesOngoing"]
      );
    }
    if (this.requestUrl["country"]) {
      this.countryList.forEach((element) => {
        this.userAboutForm.controls.country.setValue(element["name"]);
      });
    }

    let tempCirclesOfInterestIds = [];
    if (this.requestUrl["circlesOfInterest"].length > 0) {
      var j;
      for (j = 0; j < this.requestUrl["circlesOfInterest"].length; j++) {
        tempCirclesOfInterestIds.push(
          this.requestUrl["circlesOfInterest"][j]["name"]
        );
      }
      this.userAboutForm.controls.circlesOfInterest.setValue(
        tempCirclesOfInterestIds
      );
    }

    //set diseaseOfInterestIds
    let tempdiseaseOfInterestIds = [];
    if (this.requestUrl["diseaseOfInterestIds"].length > 0) {
      this.requestUrl["diseaseOfInterestIds"].forEach((element) => {
        tempdiseaseOfInterestIds.push(element["diseaseId"] || element);
      });
      this.requestUrl["diseaseOfInterestIds"] = tempdiseaseOfInterestIds;
    }
    //set researchFocus
    let tempresearchFocus = [];
    if (this.requestUrl["researchFocus"].length > 0) {
      this.requestUrl["researchFocus"].forEach((element) => {
        if (element["name"] && element["name"] !== null) {
          tempresearchFocus.push(element["name"] || element);
        }
      });
      this.requestUrl["researchFocus"] = tempresearchFocus;
    }
    //set roleIds
    let temproleIds = [];
    if (this.requestUrl["roleIds"].length > 0) {
      this.requestUrl["roleIds"].forEach((element) => {
        temproleIds.push(element["userRoleId"] || element);
      });
      this.requestUrl["roleIds"] = temproleIds;
    }
    this.requestUrl["fundingHistory"] = this.fundingHistory;
    this.requestUrl["professionalExp"] = this.professionalExp;
    this.requestUrl["education"] = this.education;
    this.requestUrl["membership"] = this.membershipList;
    this.modalRef = this.modalService.open(ViewProfileModalComponent, {
      size: "xl",
    });
    this.modalRef.componentInstance.userProfile = this.requestUrl;
    // modalRef.componentInstance.reviews = this.reviews;
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openNotificationPreferences(content) {
    const current = (this.userDetails && this.userDetails.notificationPreferences) || {};
    this.notificationPrefDraft = {};
    this.notificationPrefOptions.forEach((item) => {
      // Default to enabled when the user has no saved preference yet
      this.notificationPrefDraft[item.key] = current[item.key] !== false;
    });
    this.modalService.open(content, { centered: true });
  }

  saveNotificationPreferences(modal) {
    this.isSavingNotificationPref = true;
    const request = {
      userId: this.userId,
      notificationPreferences: { ...this.notificationPrefDraft },
    };
    this.CircleService.updateUserProfile(request).subscribe(
      (res) => {
        this.isSavingNotificationPref = false;
        if (res["message"] == "Success") {
          this._snackBar.open("Notification preferences updated successfully", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          modal.close();
          this.getUpdateProfile1();
        }
      },
      (err) => {
        this.isSavingNotificationPref = false;
      }
    );
  }

  // viewProfile() {
  //   if(this.from == 'admin') {
  //     this.router.navigate(["/main/user-profile"], {
  //       queryParams: {id:this.userId,status:'active'},
  //     });
  //   }else {

  //     this.router.navigate(["/main/user-profile"], {
  //       queryParams: {id:data.userId,status:data.status},
  //     });
  //   }
  
  // }
  save() {
    const blob = this.b64toBlob(this.croppedImage);
    this.imageChangedEvent = null;
    this.isLoading = true;
    this.CircleService.uploadImage(blob).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] === "Success") {
          this.userDetails["profilePic"] = res["data"].url;
          this.userAboutForm.controls["profilePic"].setValue(res["data"].url);
          // localStorage.setItem()
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  isUploading: boolean = true;
  cancel(): void {
    this.croppedImage = null;
    this.imageChangedEvent = null;
    this.isUploading = false;
    return;
    // setTimeout(() => {
    //     /** spinner ends after 1 seconds */
    //     this.isUploading= true;
    //   }, 1000);
  }
  fileChangeEvent(event: any): void {
    this.isLoading = true;
    let file, img;
    if (
      (file = event.target.files[0]) &&
      (file.type === "image/png" || file.type === "image/jpeg")
    ) {
      img = new Image();
      this.imageChangedEvent = event;
    } else {
      Swal.fire({
        icon: "error",
        html: "Not supported File Type. Only jpeg and png is allowed!",
      });
    }
    this.isLoading = false;
  }
  loadImageFailed() {}
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  openwebView(value) {
    let index = value.indexOf("http");
    let url = "";
    if (index == -1) {
      url = "http://" + value;
    } else {
      url = value;
    }
    window.open(url, "_blank");
  }
  onItemSelectCountry(event) {
  }
  onSelectAllCountry(event) {}
  onItemDeSelectCountry(event) {}
  onItemSelectCircle(event) {}
  onSelectAllCircle(event) {}
  onItemDeSelectCircle(event) {}
  onItemSelectRole(event) {
    this.expertCount = 0;
    for (let i = 0; i < this.userAboutForm.value.roleIds.length; i++) {
      for (let j = 0; j < this.roleList.length; j++) {
        if (
          this.userAboutForm.value.roleIds[i]["userRoleId"] ==
          this.roleList[j]["userRoleId"]
        ) {
          // if(this.roleList[j]['roleName'] == 'Researcher' || this.roleList[j]['roleName'] == 'Clinician' || this.roleList[j]['roleName'] == 'Advocacy Groups') {
          //   this.contactInfoShow= true;
          //   this.educationShow =true;
          //   this.fundingHistoryShow =  true;
          //   this.membershipShow= true;
          //   this.nbstrnShow = true;
          //   this.professionalExpShow= true;
          //   this.publicationsShow= true;
          //   this.researchExpShow =true;
          // this.expertCount = this.expertCount + 1;
          // }
          // if(this.expertCount == 0) {
          //   if(this.roleList[j]['roleName'] == 'Families and Caregivers'|| this.roleList[j]['roleName'] == 'Parents' || this.roleList[j]['roleName'] == 'Federal Groups' || this.roleList[j]['roleName'] == 'Others' || this.roleList[j]['roleName'] == 'State/Public Health Programs') {
          //     if(this.researchExpShow= false) {
          //       this.researchExpShow= false;
          //     }

          //     if(this.educationShow= false) {
          //       this.educationShow= false;
          //     }
          //     if(this.fundingHistoryShow= false) {
          //       this.fundingHistoryShow= false;
          //     }
          //     if(this.professionalExpShow= false) {
          //       this.professionalExpShow= false;
          //     }
          //     this.contactInfoShow= true;
          //     this.nbstrnShow = true;
          //     this.publicationsShow= true;

          //     this.membershipShow= true;

          //   }
          // }
          this.expertCount = this.expertCount + 1;
          this.checkRole(this.roleList[j]["formBlocks"]);
        }
      }
    }
    //If researcher, clinician or advocacy group is selected then all sections will appear otherwise
   
  }
  checkRole(userblock) {
    if (userblock["contactInfo"] == "M" || userblock["contactInfo"] == "O") {
      this.contactInfoShow = true;
    }
    if (
      userblock["contactInfo"] == "H" &&
      this.expertCount == 1 &&
      this.expertCount == 1
    ) {
      this.contactInfoShow = false;
    }

    // EDUCATION
    if (userblock["education"] == "M" || userblock["education"] == "O") {
      this.educationShow = true;
    }
    if (
      userblock["education"] == "H" &&
      this.expertCount == 1 &&
      this.expertCount == 1
    ) {
      this.educationShow = false;
    }
    // RESEARCH EXP
    if (userblock["researchExp"] == "M" || userblock["researchExp"] == "O") {
      this.researchExpShow = true;
    }
    if (
      userblock["researchExp"] == "H" &&
      this.expertCount == 1 &&
      this.expertCount == 1
    ) {
      this.researchExpShow = false;
    }

     // Professional EXP
     if (userblock["professionalExp"] == "M" || userblock["professionalExp"] == "O") {
      this.professionalExpShow = true;
    }
    if (
      userblock["professionalExp"] == "H" &&
      this.expertCount == 1 &&
      this.expertCount == 1
    ) {
      this.professionalExpShow = false;
    }


    if (userblock["membership"] == "M" || userblock["membership"] == "O") {
      this.membershipShow = true;
    }
    if (userblock["membership"] == "H" && this.expertCount == 1) {
      if ((this.membershipShow = false)) {
        this.membershipShow = false;
      }
    }

    if (userblock["nbstrn"] == "M" || userblock["nbstrn"] == "O") {
      this.nbstrnShow = true;
    }
    if (userblock["nbstrn"] == "H" && this.expertCount == 1) {
      this.nbstrnShow = false;
      if ((this.nbstrnShow = false)) {
        this.nbstrnShow = false;
      }
    }

    if (userblock["publications"] == "M" || userblock["publications"] == "O") {
      this.publicationsShow = true;
    }
    if (userblock["publications"] == "H" && this.expertCount == 1) {
      this.publicationsShow = false;
      if ((this.publicationsShow = false)) {
        this.publicationsShow = false;
      }
    }
    if (
      userblock["fundingHistory"] == "M" ||
      userblock["fundingHistory"] == "O"
    ) {
      this.fundingHistoryShow = true;
    }
    if (userblock["fundingHistory"] == "H" && this.expertCount == 1) {
      if ((this.fundingHistoryShow = false)) {
        this.fundingHistoryShow = false;
      }
    }
  }
  onSelectAllRole(event) {
    this.expertCount = 0;
    for (let i = 0; i < this.userAboutForm.value.roleIds.length; i++) {
      for (let j = 0; j < this.roleList.length; j++) {
        if (
          this.userAboutForm.value.roleIds[i]["userRoleId"] ==
          this.roleList[j]["userRoleId"]
        ) {
          this.expertCount = this.expertCount + 1;
          this.checkRole(this.roleList[j]["formBlocks"]);
        }
      }
    }
    //If researcher, clinician or advocacy group is selected then all sections will appear otherwise
  }
  onItemDeSelectRole(event) {
    this.expertCount = 0;
    for (let i = 0; i < this.userAboutForm.value.roleIds.length; i++) {
      for (let j = 0; j < this.roleList.length; j++) {
        if (
          this.userAboutForm.value.roleIds[i]["userRoleId"] ==
          this.roleList[j]["userRoleId"]
        ) {
          this.expertCount = this.expertCount + 1;
          this.checkRole(this.roleList[j]["formBlocks"]);
        }
      }
    }
    //If researcher, clinician or advocacy group is selected then all sections will appear otherwise
    if (this.expertCount == 0) {
      this.nbstrnShow = false;
      this.educationShow = false;
      this.researchExpShow = false;
      this.professionalExpShow = false;
      this.contactInfoShow = false;
      this.publicationsShow = false;
      this.researchExpShow = false;
      this.educationShow = false;
      this.fundingHistoryShow = false;
      this.membershipShow = false;
    }
  }

  profileImg(event) {
    this.selectedFile = null;
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    this.CircleService.uploadImage(this.selectedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.userDetails["profilePic"] = res["data"].url;
          this.userAboutForm.controls["profilePic"].setValue(res["data"].url);
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  getUserProfile() {
    this.isLoading = true;
    let query = "";
    if (this.userId && this.userId !== "") {
      query = "?userId=" + this.userId;
    }
    this.CircleService.getUserProfileApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.userDetails = res.data;
          if(this.from !== "admin" && this.from !== "admin1") {
            localStorage.setItem("userData", JSON.stringify(this.userDetails));
          }
          

          this.patchUserForm(this.userDetails);
          this.patchresearchForm(this.userDetails);
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  getUserRole() {
    this.isLoading = true;
    this.CircleService.getUserRole("").subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.roleList = res.data.userRolesList;
          let tempData = []
          this.roleList.forEach(element => {
              if(element['isShown'] == true) {
                tempData.push(element)
              }
          });
          this.roleList = tempData;
        } else {
          this.roleList = [];
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  getDiesease() {
    this.isLoading = true;
    this.CircleService.getUserDiseases("").subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.diseaseList = res.data.diseasesList;
          // this.PatchCircle(this.circleDetails)
        } else {
          this.diseaseList = [];
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  getFocus() {
    this.isLoading = true;
    this.CircleService.getReaarchInfo().subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.focusList = res.data.researchFocusList;
          this.focusList.push({ name: "other" });
          // this.PatchCircle(this.circleDetails)
        } else {
          this.diseaseList = [];
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  AddMemberShip() {
    let data = this.MembershipForm.value;
    if (
      this.MembershipForm.value.institution == "" &&
      this.MembershipForm.value.department == "" &&
      this.MembershipForm.value.jobTitle == "" &&
      this.MembershipForm.value.comment == "" &&
      this.MembershipForm.value.membershipYear == ""
    ) {
      return null;
    }
    this.membershipList.push(data);
    this.MembershipForm = this.fb.group({
      institution: [""],
      department: [""],
      jobTitle: [""],
      comment: [""],
      membershipYear: [""],
    });
  }
  RemoveMembership(index) {
    this.membershipList.splice(index, 1);
  }
  AddEducation() {
    let data = this.InstituteForm.value;
    if (
      this.InstituteForm.value.institution == "" &&
      this.InstituteForm.value.degree == "" &&
      this.InstituteForm.value.year == "" &&
      this.InstituteForm.value.fieldOfStudy == ""
    ) {
      return null;
    }
    this.education.push(data);
    this.InstituteForm = this.fb.group({
      institution: [""],
      degree: [""],
      year: [""],
      fieldOfStudy: [""],
    });
  }
  RemoveEducation(index) {
    this.education.splice(index, 1);
  }
  AddProffessinal() {
    let data = this.profExpForm.value;
    if (
      this.profExpForm.value.institution == "" &&
      this.profExpForm.value.jobTitle == "" &&
      this.profExpForm.value.yearStarted == "" &&
      this.profExpForm.value.yearCompleted == ""
    ) {
      return null;
    }
    this.professionalExp.push(data);
    this.profExpForm = this.fb.group({
      institution: [""],
      jobTitle: [""],
      yearStarted: [""],
      yearCompleted: [""],
    });
  }
  RemoveProffessinal(index) {
    this.professionalExp.splice(index, 1);
  }
  AddFunding() {
    let data = this.fundingForm.value;
    if (
      this.fundingForm.value.grantNo == "" &&
      this.fundingForm.value.contractNo == "" &&
      this.fundingForm.value.grantTitle == "" &&
      this.fundingForm.value.agency == ""
    ) {
      return null;
    }
    this.fundingHistory.push(data);
    this.fundingForm = this.fb.group({
      grantNo: [""],
      contractNo: [""],
      grantTitle: [""],
      agency: [""],
    });
  }
  RemoveFunding(index) {
    this.fundingHistory.splice(index, 1);
  }
  AddPublication() {
    if (this.publicationText !== "") {
      this.publications.push(this.publicationText);
    }
    this.publicationText = "";
  }
  RemovePublication(index) {
    this.publications.splice(index, 1);
  }
  AddSocial() {
    if (this.socialLink !== "" && this.socialLinkType !== "") {
      this.socialLinkList.push({
        url: this.socialLink,
        type: this.socialLinkType,
      });
    }
    this.socialLink = "";
    this.socialLinkType = "";
  }
  RemoveSocial(index) {
    this.socialLinkList.splice(index, 1);
  }

  onItemSelectProduct(event) {
    if (event.name == "other") {
      this.userAboutForm.controls.researchFocus.setValue("");
      this.isChange = true;
    }
  }

  cancelInput() {
    this.isChange = false;
    this.userAboutForm.controls.researchFocus.setValue("");
  }

  onSelectAllProduct(event) {
    
  }
  onItemDeSelect(event) {

  }

  navigateBackBtn() {
    if(this.from == "admin") {
      this.router.navigate(["/main/setting/manage-user/member"]);
      return
    }
    if(this.from == "admin1") {
      this.router.navigate(["/main/setting/manage-user/admin"]);
      return
    } else {
      //  this.router.navigate(["main/dashboard/event/discussion-board"]);
       this.router.navigate(["main/tuft-dashboard"]);
    }
  } 
  navigateBack() {
    //if status come then i will come from dashboard
    //1 from member search
    //2 from  view connection
    //3 from  send connection
    //4 from  recivvev connection
    // else {
    //   //  this.router.navigate(["main/dashboard/event/discussion-board"]);
    //    this.router.navigate(["main/tuft-dashboard"]);
    // }
    if (this.fromType == "1") {
      this.router.navigate(["main/circles/search-user"]);
      return;
    }
    if (this.fromType == "2") {
      this.router.navigate(["main/connection/your"]);
      return;
    }
    if (this.fromType == "3") {
      this.router.navigate(["main/connection/sent-req"]);
      return;
    }
    if (this.fromType == "4") {
      this.router.navigate(["main/connection/received-req"]);
      return;
    }
    if (this.fromType == "5") {
      this.router.navigate(["main/circles/search-all"]);
      return;
    }
    if(this.from == "admin") {
      this.router.navigate(["/main/setting/manage-user/member"]);
      return
    }
    if(this.from == "admin1") {
      this.router.navigate(["/main/setting/manage-user/admin"]);
      return
    }

    if (this.circleId) {
      this.router.navigate(["/main/circles/circle-profile/circle-members"], {
        queryParams: { id: this.circleId },
      });
      return
    }
      else { 
        if(this.userData['tuftsRole'].length > 1) {
          this.router.navigate(["main/dashboard/event/view-event-month"]);
          return
        } else {
          this.router.navigate(['/main/tuft-dashboard'])
          return
        }
      
      
    }
  }

  sendRequest(Id) {
    this.isLoading = true;
    let request = {
      receiverId: Id,
    };
    this.CircleService.createConnetion(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  navigateToViewProfile () {
          this.router.navigate(["/main/user-profile"], {
        queryParams: {id:this.userDetails['userId'],status:'active',from:'edit'},
      });
  }

  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}